import { acscriptsAddress } from '../appconfig';

export function fetchApi(route: string, method: string = 'GET', body?: Object, domain: string | undefined = acscriptsAddress.Registration_API) {
    return fetchApiV2(route, method, JSON.stringify(body), domain);
}

/**
 * Use for upload file feature
 */
export function fetchApiFile(route: string, body: FormData, domain: string | undefined = acscriptsAddress.Registration_API) {
    return fetch(domain + route, {
        credentials: 'include',
        method: 'POST',
        body
    }).then((response) => {
        return response.json();
    });
}

/** 
 * Fetch API - a "better" version.
 * This also do some auto processing of the response, and can be used for more cases then just JSON decode.
 * One example is handling of 204 empty response.
 * @todo: Establish API convetions - both server & client side - then improve this function following the conventions.
 */
export function fetchApiV2(route: string, method: string = 'GET', body?: Object, domain: string | undefined = acscriptsAddress.Registration_API) {
    return fetchApi2(route, method, body, domain)
        .catch(networkError)
        .then(errorIfNotOK);
}

/** 
 * Fetch API without doing JSON decode of response.
 * EHR-FE has the same function, so just use the same name for consistency sake.
 */
function fetchApi2(route: string, method: string = 'GET', body?: Object, domain: string | undefined = acscriptsAddress.Registration_API) {
    const canHaveBody: boolean = method !== 'GET';
    if (!canHaveBody && body !== undefined) {
        throw 'GET request cannot have body.';
    }

    let headers = {
        'Accept': 'application/json',
    };

    if (canHaveBody) {
        headers['Content-Type'] = 'application/json';
    }

    return fetch(domain + route, {
        credentials: 'include',
        headers,
        method: method,
        body: body
        // tslint:disable-next-line:no-any
    } as any).then((response) => {
        return response;
    });
}

// Helper functions to handle fetch response
async function errorIfNotOK(response: Response) {
    if (response.ok) {
        if (response.status === 204) {
            Promise.resolve();
        } else {
            return response.json();
        }
    } else {
        const body = await response.json();
        return Promise.reject(new Error(body.message));
    }
}

function networkError() {
    return Promise.reject(new Error('Cannot contact server. Please check your network and try again.'));
}

// Use to get claim CMS 1500 form (pdf file)
export function fetchFileApi(
    route: string,
    method: string = 'GET',
    body?: Object,
    domain: string | undefined = acscriptsAddress.EHR_API) {

    const canHaveBody: boolean = method !== 'GET' && method !== 'DELETE';
    if (!canHaveBody && body !== undefined) {
        throw `${method} request cannot have body.`;
    }
    let headers = {
        'Accept': 'application/json',
    };
    if (canHaveBody) {
        headers['Content-Type'] = 'application/json';
    }

    return fetch(domain + route, { headers, credentials: 'include', method: method, body: JSON.stringify(body) } as any).then((response: Response) => {
        if (response.ok) {
            if (response.status === 204) {
                return Promise.reject(new Error('No data'));
            } else {
                return response.blob();
            }
        } else {
            return Promise.reject(new Error(response.statusText));
        }
    });
}


// WEBPACK FOOTER //
// ./src/api/baseApi.ts